module.exports = __webpack_public_path__ + "images/alfen0607a36111833fbd4af7849a3e99009a.png";